<template>
    <a :href="url">
        <Title :title="title"></Title>
        <From :source="source" :createTime="createTime"></From>
    </a>
</template>

<script>
import Title from "./title";
import From from "./from";
export default {
    name: "OnlyTitle",
    components: {
        Title,
        From
    },
    props: {
        url: String,
        title: String,
        source: String,
        createTime: Number
    }
}
</script>

<style scoped>
</style>
